export default __webpack_public_path__ + "static/media/equity-logo-text.a9ae6764.png";